import { createAsyncThunk } from '@reduxjs/toolkit';

// Define the asyncThunk for fetching groups from Contentful
export const fetchContentGroupByName = createAsyncThunk(
  'groups/fetchByGroupName',
  async (groupName, { rejectWithValue }) => {
    const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
    const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;
    console.log(SPACE_ID, ACCESS_TOKEN, groupName);
    const url = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/master/entries?content_type=${groupName}`;

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${ACCESS_TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data from Contentful');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);